<template>
  <v-form v-model="valid" ref="mainForm">
    <MemoLive code="obj_description" v-model="sasEquivalence.objectifsDeCarriereEtFormationAuQuebec" :live="liveSasEquivalence(6109)" />
  </v-form>
</template>


<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasEquivalence() {
      return this.sas.sasEquivalence
    }
  },
  methods: {
    liveSasEquivalence(cle) {
      return { endpoint: "sas-equivalence", cle: cle, fileId: this.sasEquivalence.id }
    }
  }
}
</script>

<style>
</style>